import { use_slice_user } from '@/hooks/store/use_slices';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  page: ReactNode;
}

export function LAYOUT_PAGE__open_app_if_authorized({ page }: Props) {
  let { auth_token, open_page_after_auth } = use_slice_user(['auth_token', 'open_page_after_auth']);

  auth_token ||= '';

  let out = page;

  if (auth_token) {
    out = <Navigate to={open_page_after_auth} />;
  }

  return out;
}
